module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#trending",
      toString: function () {
        return this.url;
      }
    }